import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Sprout } from "lucide-react";

const About = () => {
  const { t } = useLang();
  return (
    <div data-testid="about-page" className="bg-[#FDFBF7]">
      {/* Hero */}
      <section className="relative overflow-hidden border-b border-stone-200">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-25"
          style={{
            backgroundImage:
              "url('https://images.pexels.com/photos/15469881/pexels-photo-15469881.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=1400')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#FDFBF7]/40 via-[#FDFBF7]/85 to-[#FDFBF7]" />
        <div className="relative container-gc px-4 sm:px-6 py-14 sm:py-20">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#F4F1EA] border border-stone-200 text-xs font-medium text-[#1E4D2B] mb-5">
              <Sprout size={14} /> {t.brand_sub}
            </div>
            <h1 data-testid="about-title" className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-stone-900 leading-tight">
              {t.about.title}
            </h1>
          </div>
        </div>
      </section>

      {/* Main content */}
      <section className="section-pad">
        <div className="container-gc max-w-3xl">
          <article data-testid="about-content" className="space-y-6 text-stone-800 text-lg sm:text-xl leading-relaxed">
            <p>
              <span className="font-semibold text-[#1E4D2B]">Welcome to Garlic Capital</span>—{t.about.p1_rest}
            </p>
            <p>{t.about.p2}</p>
            <p>{t.about.p3}</p>
          </article>

          {/* Signature accent */}
          <div className="mt-12 pt-8 border-t border-stone-200 flex items-center gap-3 text-stone-500 text-sm">
            <div className="w-10 h-10 rounded-xl bg-[#1E4D2B] text-white flex items-center justify-center">
              <Sprout size={18} />
            </div>
            <div className="leading-tight">
              <div className="font-semibold text-stone-900">{t.brand}</div>
              <div>{t.brand_sub}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
